"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _ModalHeader = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _jsxRuntime = require("react/jsx-runtime");
var _Illustration;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Header = _ref => {
  let {
    title,
    description
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader.default, {
    title: title,
    illustration: _Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
      name: "Login",
      size: "extraSmall"
    })),
    description: description
  });
};
var _default = exports.default = Header;